import React, {Component} from 'react';
import {action, observable} from 'mobx';
import {inject, observer} from 'mobx-react';

import './style.scss'
import PageTitle from "../../../components/common/PageTitle";
import FeatherIcon from 'feather-icons-react';
import moment from "moment/moment";
import ModalLoading from "../../../components/common/ModalLoading";
import {
  Badge,
  Button,
  ButtonGroup,
  FormSelect,
  Modal,
  ModalBody,
  ModalHeader
} from "shards-react";
import {reactLocalStorage as Storage} from "reactjs-localstorage";


@inject(({ teamUser }) => ({ isLogin: teamUser.isLogin, me:teamUser.me }))
@inject(({ AOA }) => ({ getEmailHistoryList:AOA.getEmailHistoryList }))

@observer
class EmailHistoryList extends Component {

  //basic
  @observable store = {};
  @observable teamUser = {};
  @observable permissions = {}
  @observable company = {};
  @observable isLogin = false;
  @observable isLoading = true;
  @observable urlParams = new URLSearchParams(window.location.search);

  //list
  @observable listParams = {
    page:1,
    limit:50,
    searchParams: {
      emailType: '',
      status: '',
      receiver: ''
    }
  }
  @observable list = {};
  @observable searchFormValue = {
    emailType: '',
    status: '',
    receiver: ''
  }

  //modals
  @observable modals = {
    isEmailDetail: false,
    emailDetailData: {},
  };

  constructor(props) {
    super(props);
    this.init()
  }

  componentDidUpdate(prevProps, prevState){

  }

  @action
  init = async (key) => {
    if(this.props.isLogin) {
      this.isLogin = this.props.isLogin;
      this.teamUser = this.props.me;
      this.store = this.teamUser.store;
      this.listParams.store_id = this.teamUser.selStore_id;
      this.listParams.limit = parseInt(await Storage.get('limitEmailHistoryList')) || this.listParams.limit;
      if(this.store.domain === "fromday.co.kr" && this.store.email === "admin@onnomads.com" && this.store.presidentName === "윤정진") {
        this.urlParamsToListParams();
      }
      else {
        window.location.replace('/signin');
      }
    }
  };

  @action
  getEmailHistoryList = async() => {
    Storage.set('limitEmailHistoryList', this.listParams.limit);
    if(this.listParams.store_id) {
      this.list = await this.props.getEmailHistoryList(this.listParams);
      console.log(this.list.docs);
      this.isLoading = false;
    }
    else {
      this.isLoading = false;
    }
  };

  urlParamsToListParams = function() {

    let searchFormValueArr = {};
    for (const key of this.urlParams.keys()) {

      if(['page'].indexOf(key) > -1 || ['limit'].indexOf(key) > -1) {
        this.listParams[key] = parseInt(this.urlParams.get(key));
      }
      else {
        if(key.indexOf('__') > -1) {
          let keyArr = key.split('__');
          if(!searchFormValueArr[keyArr[0]]) { searchFormValueArr[keyArr[0]] = {};}
          searchFormValueArr[keyArr[0]][keyArr[1]] = true;
        }
        else {
          if(this.urlParams.get(key) === "true") {
            this.searchFormValue[key] = true;
            this.listParams.searchParams[key] = true;
          }
          else if(this.urlParams.get(key) === "false") {
            this.searchFormValue[key] =  false;
            this.listParams.searchParams[key] = false;
          }
          else {
            this.searchFormValue[key] = this.urlParams.get(key);
            this.listParams.searchParams[key] = this.urlParams.get(key);
          }

        }
      }
    }

    for(let key in searchFormValueArr) {
      if(searchFormValueArr[key].all) {
        for(let deKey in this.searchFormValue[key]) {
          this.searchFormValue[key][deKey] = true;
        }
      }
      else {
        for(let deKey in this.searchFormValue[key]) {
          if(searchFormValueArr[key][deKey]) {
            this.searchFormValue[key][deKey] = true;
          }
          else {
            this.searchFormValue[key][deKey] = false;
          }
        }
      }
      this.listParams.searchParams[key] = searchFormValueArr[key];
    }


    this.getEmailHistoryList();
  }

  onChangeSearchValue = async (event) => {
    const { name, value } = event.target;
    this.searchFormValue[name] = value;
    this.listParams.searchParams[name] = value;
  };

  modalToggle = function(target, data) {
    let _this = this;
    if(!target) {
      for( var i in _this.modals) {
        if(i.indexOf('is') === 0) {
          _this.modals[i] = false;
        }
      }
    }
    else {
      _this.modals[target] = !this.modals[target];
    }

    if(data) {
      if(target === 'isEmailDetail' && data) {
        _this.modals.emailDetailData = data;
      }
      else {
        _this.modals.data = data;
      }

    }
  };

  render() {
    let _this = this;
    function Pagination() {
      let result = [];
      let totalPages = _this.list.totalPages;
      let curPageNum = _this.list.page;
      let startNum = (parseInt((curPageNum-1)/10)*10) +1;
      let endNum = startNum+9 < totalPages ? startNum+9 : totalPages;

      let urlParamsArr = new URLSearchParams(window.location.search);
      urlParamsArr.delete('page');
      let urlParams = '?' + urlParamsArr.toString();

      let rendering = () => {
        for(let i = startNum; i <= endNum; i ++) {
          if(i === curPageNum) {
            result.push(<li key={i} className="on"><a href={urlParams + "&page="+i}>{i}</a></li>);
          }
          else {
            result.push(<li key={i}><a href={urlParams + "&page="+i}>{i}</a></li>);
          }
        }
        return result;
      }

      if(_this.list && _this.list.totalPages) {
        return (
            <div className="pagination">
              <ul>
                { curPageNum !== 1 ? <li className="btn-page-first"><a href={urlParams + "&page=1"}><FeatherIcon icon="chevrons-left" className="nd-icon" /></a></li> : null}
                { startNum - 1 > 0 ? <li className="btn-page-prev"><a href={urlParams + "&page="+(startNum-1)}><FeatherIcon icon="chevron-left" className="nd-icon" /></a></li> : null}
                {rendering()}
                { endNum !== totalPages  ? <li className="btn-page-next"><a href={urlParams + "&page="+(startNum+10)}><FeatherIcon icon="chevron-right" className="nd-icon" /></a></li> : null}
                { curPageNum !== totalPages ? <li className="btn-page-last"><a href={urlParams + "&page="+totalPages}><FeatherIcon icon="chevrons-right" className="nd-icon" /></a></li> : null}
              </ul>
            </div>);
      }
      else {
        return (<></>);
      }

    }

    function GetEmailStatus(props) {
      let statusDom = '';
      switch (props.status){
        case "sent" :
          statusDom = <Badge theme="success">전송완료</Badge>;
          break;
        case "failed" :
          statusDom = <Badge theme="danger">전송실패</Badge>;
          break;
        case "pending" :
          statusDom = <Badge theme="warning">대기중</Badge>;
          break;
        default :
          statusDom = <Badge outline theme="info">{props.status}</Badge>;
          break;
      }
      return statusDom;
    }

    return (
      <div className="main-content">
        <PageTitle />
        <div className="user-list-box">
          <div className="section-box">
            <form id="" target="" className="">
              <div className="user-search-box">
                <table>
                  <tbody>
                  <tr>
                    <th>검색어</th>
                    <td>
                      <div className="search-input-box">
                        <select name="searchType" className="search-type">
                          <option value="">수신자</option>
                          <option value="">메일타입</option>
                        </select>
                        <input type="text" name="keyword" className="table-input-text search-input"/>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>메일 타입</th>
                    <td>
                      <FormSelect name="emailType"
                                  value={this.searchFormValue.emailType}
                                  onChange={event => {
                                    this.onChangeSearchValue(event)
                                  }}>
                        <option value="">전체</option>
                        <option value="noPaied">미결제</option>
                        <option value="noPeriod">기간만료</option>
                        <option value="event">이벤트</option>
                      </FormSelect>
                    </td>
                    <th>전송 상태</th>
                    <td>
                      <FormSelect name="status"
                                  value={this.searchFormValue.status}
                                  onChange={event => {
                                    this.onChangeSearchValue(event)
                                  }}>
                        <option value="">전체</option>
                        <option value="sent">전송완료</option>
                        <option value="failed">전송실패</option>
                        <option value="pending">대기중</option>
                      </FormSelect>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <div className="btn-search">
                  <input type="submit" value="검색" className="search-button"/>
                </div>
              </div>
            </form>

          </div>
          <div className="section-box">
            <form id="" target="" className="">
              <div className="user-list-table">
                <div className="user-pick-list">
                  <div className="pick-list-count">
                    검색결과 <span>{this.list.totalDocs}</span>개
                  </div>
                  <div className="choice-num-view">
                    <select name="limit"
                            value={this.listParams.limit}
                            onChange={event => {
                              this.listParams.limit = parseInt(event.target.value);
                              this.getEmailHistoryList();
                            }}
                            className="">
                      <option value="50">50개씩 보기</option>
                      <option value="100">100개씩 보기</option>
                      <option value="200">200개씩 보기</option>
                      <option value="20">20개씩 보기</option>
                    </select>
                  </div>
                </div>
                <table className="store-list">
                  <colgroup>
                    <col width="5%"/>
                    <col width="15%"/>
                    <col width="10%"/>
                    <col width="15%"/>
                    <col width="10%"/>
                    <col width="10%"/>
                    <col width="10%"/>
                    <col width=""/>
                  </colgroup>
                  <thead>
                  <tr>
                    <th>번호</th>
                    <th>스토어</th>
                    <th>메일타입</th>
                    <th>수신자</th>
                    <th>전송상태</th>
                    <th>전송일시</th>
                    <th>상세</th>
                    <th>비고</th>
                  </tr>
                  </thead>
                  <tbody>
                  {this.list && this.list.docs && this.list.docs.length > 0 ?
                      this.list.docs.map((item, i) => (
                          <tr key={i}>
                            <td className="text-center">{(this.list.page - 1) * this.list.limit + i + 1}</td>
                            <td>{item.store_id ? item.store_id.name : '-'}</td>
                            <td className="text-center">
                              {item.emailType === 'noPaied' ? '미결제' :
                               item.emailType === 'noPeriod' ? '기간만료' :
                               item.emailType === 'event' ? '이벤트' : item.emailType}
                            </td>
                            <td>{item.receiver}</td>
                            <td className="text-center"><GetEmailStatus status={item.status}></GetEmailStatus></td>
                            <td className="text-center">{moment(item.sentAt).format('YYYY-MM-DD HH:mm')}</td>
                            <td className="text-center">
                              <ButtonGroup>
                                <Button onClick={e => this.modalToggle('isEmailDetail', item)}>상세</Button>
                              </ButtonGroup>
                            </td>
                            <td className="text-left">
                              {item.errorMessage ? item.errorMessage : '-'}
                            </td>
                          </tr>))
                      :
                      <tr>
                        <td colSpan={8} className="text-center">메일 전송 내역이 없습니다</td>
                      </tr>
                  }

                  </tbody>
                </table>
                <Pagination />
              </div>
            </form>
          </div>
        </div>

        <Modal size="lg" className='modal-review-write-form' open={this.modals.isEmailDetail} toggle={() => this.modals.isEmailDetail = false} centered={true}>
          <ModalHeader toggle={() => this.modals.isEmailDetail = false}>메일 상세 보기</ModalHeader>
          <ModalBody className="history-window-popup">
            <div className="history-popup-contents">
              {this.modals.emailDetailData ? (
                  <table>
                    <colgroup>
                      <col style={{width: '20%'}}/>
                      <col style={{width: '80%'}}/>
                    </colgroup>
                    <tbody>
                    <tr>
                      <th>스토어</th>
                      <td>{this.modals.emailDetailData.store_id ? this.modals.emailDetailData.store_id.name : '-'}</td>
                    </tr>
                    <tr>
                      <th>메일 타입</th>
                      <td>{this.modals.emailDetailData.emailType === 'noPaied' ? '미결제' :
                           this.modals.emailDetailData.emailType === 'noPeriod' ? '기간만료' :
                           this.modals.emailDetailData.emailType === 'event' ? '이벤트' : this.modals.emailDetailData.emailType}</td>
                    </tr>
                    <tr>
                      <th>수신자</th>
                      <td>{this.modals.emailDetailData.receiver}</td>
                    </tr>
                    <tr>
                      <th>전송 상태</th>
                      <td><GetEmailStatus status={this.modals.emailDetailData.status}></GetEmailStatus></td>
                    </tr>
                    <tr>
                      <th>전송 일시</th>
                      <td>{this.modals.emailDetailData.sentAt ? moment(this.modals.emailDetailData.sentAt).format('YYYY-MM-DD HH:mm:ss') : '-'}</td>
                    </tr>
                    <tr>
                      <th>제목</th>
                      <td>{this.modals.emailDetailData.subject}</td>
                    </tr>
                    <tr>
                      <th>내용</th>
                      <td>
                        {this.modals.emailDetailData.body ? (
                          <div style={{maxHeight: '500px', overflowY: 'auto', border: '1px solid #e9ecef', borderRadius: '6px', padding: '10px'}}>
                            <iframe
                              srcDoc={this.modals.emailDetailData.body}
                              style={{width: '100%', minHeight: '400px', border: 'none'}}
                              title="메일 내용"
                            />
                          </div>
                        ) : (
                          <span style={{color: '#adb5bd'}}>저장된 메일 내용이 없습니다. (이전 발송 건은 내용이 저장되지 않았을 수 있습니다)</span>
                        )}
                      </td>
                    </tr>
                    {this.modals.emailDetailData.errorMessage ? (
                      <tr>
                        <th>오류 메시지</th>
                        <td className="text-red">{this.modals.emailDetailData.errorMessage}</td>
                      </tr>
                    ) : null}
                    </tbody>
                  </table>) : null}

              <div className="text-center mt-2">
                <Button className="ml-2" theme="light" onClick={event => this.modals.isEmailDetail = false}>닫기</Button>
              </div>
            </div>

          </ModalBody>
        </Modal>
        <ModalLoading isLoading={this.isLoading}/>
      </div>
    )
  }
}

export default EmailHistoryList;